module.exports = __webpack_public_path__ + "static/img/certificate-frm.462e4943.png";